import ADB from "../../../libs/MediaSDK";
import globals from "../../globals";
import { akamai } from '../../globals';
import { debug } from "../../utils/debug-log";
import getSecondsFromTimeString from "../../utils/get-seconds-from-time-string";
import { Chapters, DisplayState, QoE, InFocus, ClosedCaptions, Mute, PlayState, Buffering } from "./modules";


function lowerCase(str) {
  let obj = str;
  if (typeof str === "string") {
    obj = str.toLowerCase();
  }
  return obj;
}
export default class MediaAnalyticsTrackingProxy {
  constructor(amp, trackingConfig) {

    this.started = false;
    this._amp = amp;
    this._trackingConfig = trackingConfig;
    this._subscriptions = [];


    this._stateObjects = null;
    this._playState = null;
    this._infocus;
    this._tracker = null;
    this._chapters = null;
    this._qoe = null;
    this._displayState = null;
    this._closedCaptions = null;
    this._mute = null;
    this._buffering = null;
  }
  get amp() {
    return this._amp;
  }
  get buffering() {
    if (this._buffering == null) {
      const { amp, tracker, stateObjects } = this;
      this._buffering = new Buffering(amp, tracker, stateObjects);
    }
    return this._buffering;
  }
  get chapters() {
    if (this._chapters == null) {
      const { amp, tracker } = this;
      this._chapters = new Chapters(amp, tracker);
    }
    return this._chapters;
  }
  get closedCaptions() {
    if (this._closedCaptions == null) {
      const { amp, tracker, stateObjects } = this;
      this._closedCaptions = new ClosedCaptions(amp, tracker, stateObjects);
    }
    return this._closedCaptions;
  }
  get contextData() {
    let { media } = this.amp;
    let { title } = media;
    const { toolin } = this.trackingConfig;
    let titleEl = document.createElement("div");
    titleEl.innerHTML = title;
    title = titleEl.textContent;  // Strip HTML from title
    let { videoId, duration } = media.metadata;
    const { moduleName } = this.trackingConfig;
    //const { s_gi, s_account } = window;
    const asset = `${moduleName}-${videoId}`;
    const { s_md } = window;
    // Fix for contextData reduction
    const contextData = Object.entries(s_md.contextData).reduce((acc, [key, value]) => {
      if (key.startsWith("wb.")) {
        const dataKey = key.replace("wb.", "");  // Remove 'wb.' prefix
        acc[dataKey] = value;
      }
      return acc;
    }, {});

    const customData = {
      ...contextData,
      asset: lowerCase(asset),
      vpagename: s_md.pageName,
      "a.media.friendlyName": lowerCase(title),
      "a.media.name": videoId,
      "a.media.playerName": "media-amp",
      "a.media.pageName": s_md.pageName,
      "a.media.length": duration,
      "a.media.channel": s_md.contextData["wb.chn"] || "",  // Default to empty string
      "a.media.extcampaign": s_md.contextData["wb.ecd"] || ""
    };
    debug.log("[MediaAnalyticsTracking][Proxy] custom data:", customData);
    return customData;  // Ensure the customData is returned
  }

  get displayState() {
    if (this._displayState == null) {
      const { amp, tracker, stateObjects } = this;
      this._displayState = new DisplayState(amp, tracker, stateObjects)
    }
    return this._displayState;
  }
  get infocus() {
    if (this._infocus == null) {
      const { amp, tracker, stateObjects } = this;
      this._infocus = new InFocus(amp, tracker, stateObjects)
    }
    return this._infocus;
  }
  get mediaObject() {
    let { media } = this.amp;
    let { title, duration } = media;
    let { videoId } = media.metadata;
    const streamType =
      media.medium === "audio"
        ? ADB.Media.StreamType.AOD
        : ADB.Media.StreamType.VOD;
    const mediaType =
      media.medium === "audio"
        ? ADB.Media.MediaType.Audio
        : ADB.Media.MediaType.Video;
    let mediaObject = ADB.Media.createMediaObject(
      title,
      videoId,
      getSecondsFromTimeString(duration),
      streamType,
      mediaType
    );

    debug.log("[MediaAnalyticsTrackingProxy] mediaObject:", mediaObject);
    return mediaObject;
  }
  get mute() {
    if (this._mute == null) {
      const { amp, tracker, stateObjects } = this;
      this._mute = new Mute(amp, tracker, stateObjects)
    }
    return this._mute;
  }
  get playState() {
    if (this._playState == null) {
      const { amp, tracker, stateObjects } = this;
      this._playState = new PlayState(amp, tracker, stateObjects)
    }
    return this._playState;
  }
  get qoe() {
    if (this._qoe == null) {
      const { amp, tracker, stateObjects } = this;
      this._qoe = new QoE(amp, tracker)
    }
    return this._qoe;
  }

  get stateObjects() {
    if (this._stateObjects == null) {
      this._stateObjects = {};
      const stateKeys = Object.keys(ADB.Media.PlayerState);
      stateKeys.forEach((key) => {
        this._stateObjects[key] = ADB.Media.createStateObject(key);
      });
      debug.log("[MediaAnalyticsTracking][Proxy] stateObjects:", this._stateObjects);
    }

    return this._stateObjects;
  }
  get subscriptions() {
    return this._subscriptions;
  }
  get tracker() {
    if (this._tracker == null) {
      const { amp } = this;
      const tracker = ADB.Media.getInstance();
      this.amp.container.tracker = tracker;
      amp.container.tracker = tracker;
      this._tracker = tracker;
      //window.tracker = this._tracker;
    }
    return this._tracker;
  }

  get trackingConfig() {
    return this._trackingConfig;
  }
  get trackingEvents() {
    const { TIME_UPDATE, LOADED_DATA, STARTED, ENDED, ERROR, TRACK_ERROR, PLAY, MEDIA_CHANGE, DESTROY } = akamai.amp.Events;
    let trackingEvents = [
      TIME_UPDATE, LOADED_DATA, STARTED, ENDED, ERROR, TRACK_ERROR, PLAY, MEDIA_CHANGE, DESTROY
    ];

    return trackingEvents;
  }
}
